<template>
<div class="modal fade" ref="modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header py-2 pe-2">
                <strong class="modal-title">
                    <template v-if="cloneSessionId">
                        CLONA ATTIVITÀ
                    </template>
                    <template v-else>
                        NUOVA ATTIVITÀ
                    </template>
                </strong>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="isLoading">
                    <p>Caricamento...</p>
                </div>
                <form v-else>
                    <template v-if="cloneSessionId">
                        <div class="row g-lg-3 mb-3">
                            <p>
                                Tutti i materiali presenti nell'attività verranno inseriti nella nuova attività.
                            </p>
                        </div>
                    </template>

                    <MbInputErrors 
                        :errors="errors"
                        name="form">
                    </MbInputErrors>

                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="limite_giornaliero" class="col-form-label">Titolo*</label>
                        </div>
                        <div class="col">
                            <input type="text" v-model="form.title" class="form-control" maxlength="255">
                            <div class="invalid-feedback">Specificare un valore</div>
                            <MbInputErrors 
                                :errors="errors"
                                name="title">
                            </MbInputErrors>
                        </div>
                    </div>

                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label class="col-form-label">Attività da fare entro:</label>
                        </div>
                        <div class="col d-flex align-items-center">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="form.limitDate"
                                >
                            </div>
                            <MbInputErrors 
                                :errors="errors"
                                name="limitDate">
                            </MbInputErrors>
                        </div>
                    </div>

                    <!-- Data inizio / Data fine-->
                    <div v-if="form.limitDate" class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="date2" class="col-form-label">Data*</label>
                        </div>
                        <div class="col">
                            <input type="date" v-model="form.toDate"  class="form-control" required="">
                            <div class="invalid-feedback">Specificare data fine</div>
                            <MbInputErrors 
                                :errors="errors"
                                name="toDate">
                            </MbInputErrors>
                        </div>
                    </div>

                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="note" class="col-form-label">Note</label>
                        </div>
                        <div class="col">
                            <textarea name="note" v-model="form.note" class="form-control" placeholder=""></textarea>
                            <div class="invalid-feedback">Specificare una data</div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary close-btn" 
                    v-if="!isLoading"
                    @click="onClickSave()">
                    <span class="bi-check2-circle"></span>
                    Salva e assegna esercizi
                </button>
            </div>
        </div>
    </div>
</div>
</template>
<script>

import axios from 'axios'
import MbInputErrors from "@/components/ui/base/MbInputErrors"

export default{
    components: {
        MbInputErrors
    },
    props: {
        userId: Number,
        relatedUserId: Number,
        type: String,
        cloneSessionId: Number
    },
    data(){
        return {
            isLoading: false,
            errors: {},
            modal: null,
            form: {
                sessionId: null,
                userId: null,
                title: '',
                
                limitDate: 0,
                toDate: null,

                note: null
            }
        }
    },
    mounted(){
    },
    methods: {
        toggle(){
            if (this.modal == null){
                this.modal = new window.bootstrap.Modal(this.$refs.modal)
            }
            
            this.modal.toggle()
        },
        loadSessionData(sessionId){
            this.isLoading = true
            axios.get('/structure/session/UserSessionAction-getSession?sessionId=' + sessionId)
                .then((response) => {
                    this.isLoading = false

                    if (response.hasErrors){
                        return
                    }

                    this.form = response.data.result
                    this.toggle()
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        onClickSave(){
            let _this = this

            this.form.type = this.type
            this.form.userId = this.userId
            this.form.relatedUserId = this.relatedUserId
            this.form.cloneSessionId = this.cloneSessionId

            axios.post('/structure/session/UserSessionAction-postSession', this.form)
                .then((response) => {
                    if (!response.data.success){
                        let errors = response.data.result
                        errors['form'] = response.data.errors

                        _this.$set(_this, "errors", errors)
                        return
                    }

                    if (this.cloneSessionId){
                        let newSessionId = response.data.result.sessionId
                        this.$emit('cloned', newSessionId)
                        return
                    }

                    this.toggle()
                    this.$emit('reload')
                })
                .catch((error) => {
                    _this.$set(_this.errors, "form", [error])
                })
        }
    }
}
</script>